import styled from '@emotion/styled';
import { ICarouselSectionEntry } from '../../../../contentful/types/ICarouselSection';
import Subheading from '../../../../components/common/headings/Subheading';
import { CarouselItem } from '../../../../components/common/carousel/CarouselItem';
import Carousel from '../../../../components/common/carousel/Carousel';
import ImageCard from '../../../../components/common/carousel/ImageCard';
import { ContentWrap, Css, H3, Responsive } from '../../../../ui';

interface ICarouselSectionProps {
	id: string;
	section: ICarouselSectionEntry;
}

export default function CarouselSection({
	id,
	section,
}: ICarouselSectionProps) {
	const { title, subtitle, items } = section.fields;

	return (
		<Section id={id}>
			<ContentWrap>
				{!title && subtitle && <Subheading type="h3">{subtitle}</Subheading>}

				{title && (
					<H3 styling="h4">
						{subtitle && <Subheading type="h3">{subtitle}</Subheading>}
						{title}
					</H3>
				)}
			</ContentWrap>

			<Carousel>
				{items.map(
					(item, index) =>
						item.fields.image && (
							<CarouselItem
								key={item.id}
								ariaSlideIndex={index}
								ariaSlideTitle={
									item.fields.title || item.fields.image.fields.title || ''
								}
								ariaTotalNumberOfSlides={items.length || 0}
							>
								<ImageCard
									alt={
										item.fields.title ||
										item.fields.image.fields.title ||
										item.fields.image.fields.file.fileName
									}
									item={item.fields.image}
								/>
							</CarouselItem>
						),
				)}
			</Carousel>
		</Section>
	);
}

const Section = styled.section<{}>`
	padding: ${Css.pxToRem(32)} 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		h3 {
			font-size: ${Css.pxToRem(32)};
		}
	}
`;
